import * as backend from '../backend-helpers/main';
import {mapNeoPersonalRoomToRoomItem, mapNeoRoomToRoomItem} from '../utils/rooms';

//const GET_ROOMS_HD_REQUEST = "GET_ROOMS_HD_REQUEST";
//const GET_ROOMS_HD_SUCCESS = "GET_ROOMS_HD_SUCCESS";
//const GET_ROOMS_HD_FAILURE = "GET_ROOMS_HD_FAILURE";

const GET_ROOMS_NEO_REQUEST = "GET_ROOMS_NEO_REQUEST";
const GET_ROOMS_NEO_SUCCESS = "GET_ROOMS_NEO_SUCCESS";
const GET_ROOMS_NEO_FAILURE = "GET_ROOMS_NEO_FAILURE";

const GET_PERSONAL_ROOMS_REQUEST = "GET_PERSONAL_ROOMS_REQUEST";
const GET_PERSONAL_ROOMS_SUCCESS = "GET_PERSONAL_ROOMS_SUCCESS";
const GET_PERSONAL_ROOMS_FAILURE = "GET_PERSONAL_ROOMS_FAILURE";

const GET_LAST_REAL_GIFT_REQUEST = "GET_LAST_REAL_GIFT_REQUEST";
const GET_LAST_REAL_GIFT_SUCCESS = "GET_LAST_REAL_GIFT_SUCCESS";
const GET_LAST_REAL_GIFT_FAILURE = "GET_LAST_REAL_GIFT_FAILURE";

const GET_LAST_WALL_MATERIALS_REQUEST = "GET_LAST_WALL_MATERIALS_REQUEST";
const GET_LAST_WALL_MATERIALS_SUCCESS = "GET_LAST_WALL_MATERIALS_SUCCESS";
const GET_LAST_WALL_MATERIALS_FAILURE = "GET_LAST_WALL_MATERIALS_FAILURE";

const GET_LAST_BOBSTORE_WARDROBE_REQUEST = "GET_LAST_BOBSTORE_WARDROBE_REQUEST";
const GET_LAST_BOBSTORE_WARDROBE_SUCCESS = "GET_LAST_BOBSTORE_WARDROBE_SUCCESS";
const GET_LAST_BOBSTORE_WARDROBE_FAILURE = "GET_LAST_BOBSTORE_WARDROBE_FAILURE";


const GET_LAST_BOBSTORE_SUBMISSION_REQUEST = "GET_LAST_BOBSTORE_SUBMISSION_REQUEST";
const GET_LAST_BOBSTORE_SUBMISSION_SUCCESS = "GET_LAST_BOBSTORE_SUBMISSION_SUCCESS";
const GET_LAST_BOBSTORE_SUBMISSION_FAILURE = "GET_LAST_BOBSTORE_SUBMISSION_FAILURE";

const GET_LATEST_FILMS_AMATEURS_REQUEST = "GET_LATEST_FILMS_AMATEURS_REQUEST";
const GET_LATEST_FILMS_AMATEURS_SUCCESS = "GET_LATEST_FILMS_AMATEURS_SUCCESS";
const GET_LATEST_FILMS_AMATEURS_FAILURE = "GET_LATEST_FILMS_AMATEURS_FAILURE";

const GET_LAST_VIRTUAL_GIFT_REQUEST= "GET_LAST_VIRTUAL_GIFT_REQUEST";
const GET_LAST_VIRTUAL_GIFT_SUCCESS = "GET_LAST_VIRTUAL_GIFT_SUCCESS";
const GET_LAST_VIRTUAL_GIFT_FAILURE = "GET_LAST_VIRTUAL_GIFT_FAILURE";

const GET_MESSAGE_OF_DAY_REQUEST= "GET_MESSAGE_OF_DAY_REQUEST";
const GET_MESSAGE_OF_DAY_SUCCESS = "GET_MESSAGE_OF_DAY_SUCCESS";
const GET_MESSAGE_OF_DAY_FAILURE = "GET_MESSAGE_OF_DAY_FAILURE";

const GET_PAYMENT_TEXT_REQUEST= "GET_PAYMENT_TEXT_REQUEST";
const GET_PAYMENT_TEXT_SUCCESS = "GET_PAYMENT_TEXT_SUCCESS";
const GET_PAYMENT_TEXT_FAILURE = "GET_PAYMENT_TEXT_FAILURE";

const GET_FAVOURITES_REQUEST = "GET_FAVOURITES_REQUEST";
const GET_FAVOURITES_SUCCESS = "GET_FAVOURITES_SUCCESS";
const GET_FAVOURITES_FAILURE = "GET_FAVOURITES_FAILURE";

const GET_GENEROUS_USERS_REQUEST = "GET_GENEROUS_USERS_REQUEST";
const GET_GENEROUS_USERS_SUCCESS = "GET_GENEROUS_USERS_SUCCESS";
const GET_GENEROUS_USERS_FAILURE = "GET_GENEROUS_USERS_FAILURE";

const initState = {
    rooms: null,
    personal_rooms: null,
    last_real_gifts: [],
    last_wall_posts: [],
    last_bobstore_wardrobe: [],
    last_bobstore_submissions: [],
    latest_films_amateurs: [],
    last_virtual_gifts: [],
    site_description: null,
    payment_description: null,
    favourites: {
        isLoading: false,
        list: null,
        totalCount: 0,
        page: 1,
    },
    generousUsers: {
        isLoading: false,
        list: null,
        totalCount: 0,
        page: 1,
    }
};

export default function main(state = initState, action) {
    let result = Object.assign({}, state);

    switch (action.type) {
/*
 *        case GET_ROOMS_HD_SUCCESS: {
 *            let resultRooms = result.rooms || [],
 *                actionRooms = action.result.data && action.result.data.map ? action.result.data : [];
 *
 *            result.rooms = [
 *                ...resultRooms.filter((item) => item._type !== 'hd'),
 *                ...actionRooms.map(mapHdRoomToRoomItem)
 *            ];
 *            break;
 *        }
 */
        case GET_ROOMS_NEO_SUCCESS: {
            let resultRooms = result.rooms || [],
                actionRooms = action.result.data && action.result.data.map ? action.result.data : [];

            result.rooms = [
                ...resultRooms.filter((item) => item._type !== 'neo'),
                ...actionRooms.map(mapNeoRoomToRoomItem)
            ];
            break;
        }

        case GET_PERSONAL_ROOMS_SUCCESS: {
            result.personal_rooms = action.result.data.map(mapNeoPersonalRoomToRoomItem);
            result.personal_rooms.sort((room1, room2) => room1.userCount > room2.userCount ? -1 : 1);

            break;
        }

        case GET_LAST_REAL_GIFT_SUCCESS: {
            result.last_real_gifts = action.result.data;
            break;
        }

        case GET_LAST_WALL_MATERIALS_SUCCESS: {
            result.last_wall_posts = action.result.data;
            break;
        }

        case GET_LAST_BOBSTORE_WARDROBE_SUCCESS: {
            result.last_bobstore_wardrobe = action.result.data;
            break;
        }

        case GET_LAST_BOBSTORE_SUBMISSION_SUCCESS: {
            result.last_bobstore_submissions = action.result.data;
            break;
        }

        case GET_LATEST_FILMS_AMATEURS_SUCCESS: {
            result.latest_films_amateurs = action.result.data;
            break;
        }

        case GET_LAST_VIRTUAL_GIFT_SUCCESS: {
            result.last_virtual_gifts = action.result.data;
            break;
        }

        case GET_MESSAGE_OF_DAY_SUCCESS: {
            result.site_description = action.result.data.message_of_day;
            break;
        }

        case GET_PAYMENT_TEXT_SUCCESS: {
            result.payment_description = action.result.data.message_of_day;
            break;
        }

        case GET_FAVOURITES_REQUEST: {
            result.favourites = Object.assign({}, result.favourites, {isLoading: true, list: []});
            break;
        }

        case GET_FAVOURITES_SUCCESS: {
            result.favourites = action.result.data;
            result.favourites.isLoading = false;
            result.favourites.page = action.page;
            break;
        }

        case GET_GENEROUS_USERS_REQUEST: {
            result.generousUsers = Object.assign({}, result.generousUsers, {isLoading: true, list: []});
            break;
        }

        case GET_GENEROUS_USERS_SUCCESS: {
            result.generousUsers = action.result.data;
            result.generousUsers.isLoading = false;
            result.generousUsers.page = action.page;
            break;
        }

    }

    return result;
}
/*
 *export function getRoomsHd(data)
 *{
 *    return {
 *        types: [GET_ROOMS_HD_REQUEST, GET_ROOMS_HD_SUCCESS, GET_ROOMS_HD_FAILURE],
 *        promise: backend.getRoomsHd()
 *    }
 *}
 */

export function getRoomsNeo(data)
{
    return {
        types: [GET_ROOMS_NEO_REQUEST, GET_ROOMS_NEO_SUCCESS, GET_ROOMS_NEO_FAILURE],
        promise: backend.getRoomsNeo()
    }
}

export function getPersonalRooms(data)
{
    return {
        types: [GET_PERSONAL_ROOMS_REQUEST, GET_PERSONAL_ROOMS_SUCCESS, GET_PERSONAL_ROOMS_FAILURE],
        promise: backend.getPersonalRooms()
    }
}

export function getLastRealGifts(limit)
{
    return {
        types: [GET_LAST_REAL_GIFT_REQUEST, GET_LAST_REAL_GIFT_SUCCESS, GET_LAST_REAL_GIFT_FAILURE],
        promise: backend.getRealGiftsIndex(limit)
    }
}

export function getLastWallMaterials(limit)
{
    return {
        types: [GET_LAST_WALL_MATERIALS_REQUEST, GET_LAST_WALL_MATERIALS_SUCCESS, GET_LAST_WALL_MATERIALS_FAILURE],
        promise: backend.getLastWallMaterialsIndex(limit)
    }
}

export function getLastBobstoreWardrobe(limit)
{
    return {
        types: [GET_LAST_BOBSTORE_WARDROBE_REQUEST, GET_LAST_BOBSTORE_WARDROBE_SUCCESS, GET_LAST_BOBSTORE_WARDROBE_FAILURE],
        promise: backend.getLastBobstoreWardrobeIndex(limit)
    }
}

export function getLastBobstoreSubmissions(limit)
{
    return {
        types: [GET_LAST_BOBSTORE_SUBMISSION_REQUEST, GET_LAST_BOBSTORE_SUBMISSION_SUCCESS, GET_LAST_BOBSTORE_SUBMISSION_FAILURE],
        promise: backend.getLastBobstoreSubmissionsIndex(limit)
    }
}

export function getLatestFilmsAmateurs(limit)
{
    return {
        types: [GET_LATEST_FILMS_AMATEURS_REQUEST, GET_LATEST_FILMS_AMATEURS_SUCCESS, GET_LATEST_FILMS_AMATEURS_FAILURE],
        promise: backend.getLastFilmsAmateursIndex(limit)
    }
}

export function getLastVirtualGifts(limit)
{
    return {
        types: [GET_LAST_VIRTUAL_GIFT_REQUEST, GET_LAST_VIRTUAL_GIFT_SUCCESS, GET_LAST_VIRTUAL_GIFT_FAILURE],
        promise: backend.getLastVirtualGiftsIndex(limit)
    }
}

export function getMessageOfDay(id)
{
    return {
        types: [GET_MESSAGE_OF_DAY_REQUEST, GET_MESSAGE_OF_DAY_SUCCESS, GET_MESSAGE_OF_DAY_FAILURE],
        promise: backend.getMessageOfDay(id)
    }
}

export function getPaymentText(id)
{
    return {
        types: [GET_PAYMENT_TEXT_REQUEST, GET_PAYMENT_TEXT_SUCCESS, GET_PAYMENT_TEXT_FAILURE],
        promise: backend.getMessageOfDay(id)
    }
}

export function getFavourites({page, limit})
{
    return {
        types: [GET_FAVOURITES_REQUEST, GET_FAVOURITES_SUCCESS, GET_FAVOURITES_FAILURE],
        promise: backend.getFavouritesIndex(page, limit),
        page
    }
}

export function getGenerousUsers({page, limit})
{
    return {
        types: [GET_GENEROUS_USERS_REQUEST, GET_GENEROUS_USERS_SUCCESS, GET_GENEROUS_USERS_FAILURE],
        promise: backend.getGenerousUsersIndex(page, limit),
        page
    }
}


// WEBPACK FOOTER //
// ./src/reducers/main.js